// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form { 
    display: block;
    background-color: white;
}
.login-form h2 {
    text-align: center;
}
.login-form .submit {
    text-align: center;
}
.login-form .error {
    text-align: center;
    color: red;
}
.login-form .inner-wrapper {
    text-align: center;
    padding: 10px 0 20px 0;
}
.login-form .forgot-password {
    padding: 15px 0;
}

@media (width >= 700px) {
    .login-form { 
        display: block;
        box-sizing: border-box;
        padding: 20px;
        border: thin solid var(--main-border-color);
        border-radius: 10px;
        max-width: 500px;
        margin: 0 auto;
    }
    .login-form .inner-wrapper {
        margin: 10px auto;
        width: 430px;
    }
    .login-form .field-wrapper {
        display: flex;
        box-sizing: border-box;
        padding: 10px;
    }
    .login-form .field-wrapper.submit {
        justify-content: center;
    }
}
@media (width < 700px) {
    .login-form { 
        display: block;
        box-sizing: border-box;
        padding: 10px;
        width: 100%;
        border-top: thin solid var(--main-border-color);
        border-bottom: thin solid var(--main-border-color);
    }

    .login-form .field-wrapper {
        box-sizing: border-box;
        padding: 10px 0;
    }
}

`, "",{"version":3,"sources":["webpack://./client/components/authentication/LoginForm.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,cAAc;QACd,sBAAsB;QACtB,aAAa;QACb,2CAA2C;QAC3C,mBAAmB;QACnB,gBAAgB;QAChB,cAAc;IAClB;IACA;QACI,iBAAiB;QACjB,YAAY;IAChB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,aAAa;IACjB;IACA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,cAAc;QACd,sBAAsB;QACtB,aAAa;QACb,WAAW;QACX,+CAA+C;QAC/C,kDAAkD;IACtD;;IAEA;QACI,sBAAsB;QACtB,eAAe;IACnB;AACJ","sourcesContent":[".login-form { \n    display: block;\n    background-color: white;\n}\n.login-form h2 {\n    text-align: center;\n}\n.login-form .submit {\n    text-align: center;\n}\n.login-form .error {\n    text-align: center;\n    color: red;\n}\n.login-form .inner-wrapper {\n    text-align: center;\n    padding: 10px 0 20px 0;\n}\n.login-form .forgot-password {\n    padding: 15px 0;\n}\n\n@media (width >= 700px) {\n    .login-form { \n        display: block;\n        box-sizing: border-box;\n        padding: 20px;\n        border: thin solid var(--main-border-color);\n        border-radius: 10px;\n        max-width: 500px;\n        margin: 0 auto;\n    }\n    .login-form .inner-wrapper {\n        margin: 10px auto;\n        width: 430px;\n    }\n    .login-form .field-wrapper {\n        display: flex;\n        box-sizing: border-box;\n        padding: 10px;\n    }\n    .login-form .field-wrapper.submit {\n        justify-content: center;\n    }\n}\n@media (width < 700px) {\n    .login-form { \n        display: block;\n        box-sizing: border-box;\n        padding: 10px;\n        width: 100%;\n        border-top: thin solid var(--main-border-color);\n        border-bottom: thin solid var(--main-border-color);\n    }\n\n    .login-form .field-wrapper {\n        box-sizing: border-box;\n        padding: 10px 0;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
